import { ChangeOrderChoice } from "./changeorderchoice";
import { ChangeOrderChoiceAttribute } from "./changeorderchoiceattribute";
import { ChangeOrderChoiceLocation } from "./changeorderchoicelocation";
import { ChangeOrderChoiceLocationAttribute } from "./changeorderchoicelocationattribute";
import { ChangeOrderPlanOptionAttribute } from "./changeorderplanoptionattribute";
import { ChangeOrderPlanOptionLocation } from './changeorderplanoptionlocation';
import { JobOptionTypeName } from './enums/jobOptionTypeName';

export class ChangeOrderPlanOption {
    public id: number;
    public planOptionId: number;
    public action: string;
    public qty: number;
    public listPrice: number;
    public optionSalesName: string;
    public optionDescription: string;
    public jobOptionTypeName: JobOptionTypeName;
    public locations: string [];
    public financialOptionIntegrationKey: string;
    public optionCategoryId: number;
    public optionCategoryName: string;
    public changeOrderPlanOptionAttributes: ChangeOrderPlanOptionAttribute[];
    public changeOrderPlanOptionLocations: ChangeOrderPlanOptionLocation[];
    public changeOrderChoices: ChangeOrderChoice[];
    public changeOrderChoiceAttributes: ChangeOrderChoiceAttribute[];
    public changeOrderChoiceLocations: ChangeOrderChoiceLocation[];
}